module.exports = __webpack_public_path__ + "static/media/hook.873b341d.svg";